import type { PermissionLevel } from '../../../store/useEmployeesStore';

export type LevelOption = {
  level: PermissionLevel;
  label: string;
  shortLabel: string;
};

const MODULES_WITH_VOID = new Set(['POS', 'Expenses', 'Cash', 'Purchases']);
const MODULES_WITH_DISCOUNT = new Set(['POS']);

export function levelsForModule(module: string): LevelOption[] {
  const options: LevelOption[] = [
    { level: 'none', label: 'Sin acceso', shortLabel: 'Ninguno' },
    { level: 'view', label: 'Solo lectura', shortLabel: 'Ver' },
    { level: 'edit', label: 'Editar', shortLabel: 'Editar' },
  ];
  if (MODULES_WITH_VOID.has(module)) {
    options.push({ level: 'edit-void', label: 'Editar y anular', shortLabel: '+ Anular' });
  }
  if (MODULES_WITH_DISCOUNT.has(module)) {
    options.push({
      level: 'edit-void-discount',
      label: 'Editar, anular y descontar',
      shortLabel: '+ Descontar',
    });
  }
  return options;
}

export function permissionLevelShortLabel(
  module: string,
  level: PermissionLevel
): string {
  const opt = levelsForModule(module).find((o) => o.level === level);
  return opt?.shortLabel ?? '—';
}
